export const environment = {
    trazeApi: 'https://golive-test.trazeapi.com/api',
    trazeApiImages: {
        host: 'https://golive-test.trazeapi.com/image'
    },
    apiUrl: 'https://api-golive-test.trazeapp.com'
};
